module.exports = function () {
    let showLogo = false;
    
    if ( document.querySelector(".hero-seashell") ) {
        const hero = document.querySelector(".hero-seashell"),
            cLogo = document.querySelector(".main-c-logo");

        const visibleCLogo = () => {
           if ( ( hero.getBoundingClientRect().bottom - document.querySelector(".header").getBoundingClientRect().height ) <= 0 ) {
               cLogo.classList.remove(  "opacity-0", "invisible");
               showLogo = true;
           }
           else {
               cLogo.classList.add("opacity-0", "invisible");
               showLogo = false;
           }
        }
        
        visibleCLogo();
        window.addEventListener("scroll", visibleCLogo);
        window.addEventListener("resize", visibleCLogo);
    }
    else {
        showLogo = true;
    }

    
    if ( document.querySelector('.main-c-logo') ) {
        const cMainLogo = document.querySelector('.main-c-logo');
        const footer = document.querySelector('footer');
        const windowHeightCalc = window.innerHeight / 12 * 11;

        const fadeOutCLogo = () => {
           if ( showLogo ) {
               if ( window.scrollY + windowHeightCalc >= footer.offsetTop ) {
                   cMainLogo.classList.add("opacity-0", "invisible");
               } else {
                   cMainLogo.classList.remove("opacity-0", "invisible");
               }
           }
        }

        fadeOutCLogo();
        window.addEventListener("scroll", fadeOutCLogo);
    }
}